<template>
    <main>
        <Banner />
        <Products />
        <Promises />
    </main>
</template>

<script>
import Banner from './_banner'
import Products from './ProductList'
import Promises from './_promises'

export default {
    components: {
        Banner,
        Products,
        Promises
    }
}
</script>